module.exports = __webpack_public_path__ + "static/hermanos-fd2fd8d95ba4aba70cc8cfdc3ac6e72f.jpg";